import { Task, TaskState } from "./protogen/planning/service_pb";

const OPEN_STATES = [ TaskState.INACTIVE, TaskState.IN_PROGRESS ];

function getTaskObject(taskObjOrProto: Task|Task.AsObject): Task.AsObject {
  return (taskObjOrProto instanceof Task) ? taskObjOrProto.toObject() :
                                            taskObjOrProto;
}

export function isTaskClosed(taskObjOrProto: Task|Task.AsObject): boolean {
  return !OPEN_STATES.includes(getTaskObject(taskObjOrProto).taskState);
}

export function isTaskOpen(taskObjOrProto: Task|Task.AsObject): boolean {
  return OPEN_STATES.includes(getTaskObject(taskObjOrProto).taskState);
}
